/* eslint-disable indent */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */
import React from 'react';
import { View, StyleSheet } from 'react-native';
import { connect } from 'react-redux';
import { getFocusedRouteNameFromRoute } from '@react-navigation/native';

import { isPhone, settingsLine, Popup } from '@helpers';
import { width, scale, role } from '@components/frame';
import ColorWrapper from '@styles/colors';

import SettingNavigation from './v2/common/navigation';

import ActivateDevice from './components/common/activateDevice';

import ChangeLanguageModal from './components/modules/changeLanguage';
import ChangeThemeModal from './components/modules/changeTheme';
import InviteUserModal from './v2/structure/users/users/inviteUser';
import AddMachineModal from './v2/structure/machines/machines/addMachine';
import AddTool from '@components/tool/components/addTool';

import Navigation from './navigation';

const Profile = (props) => {
  const { C, toggleInviteUser, toggleAddTool, route, navigation, toggleAddMachine } = props;
  const selectedTab = getFocusedRouteNameFromRoute(route) || 'Account';

  if (!isPhone) {
    return (
      <View style={{ width: '100%', height: '100%', alignItems: 'center' }}>
        <View style={{ width, height: '100%', flexDirection: 'row' }}>
          <View
            style={{
              width: scale(284),
              borderRightColor: C('Hairline/Light/No trans'),
              borderRightWidth: StyleSheet.hairlineWidth,
            }}
          >
            <SettingNavigation
              {...{ C, tabs: settingsLine, selectedTab, scale, toggleInviteUser, toggleAddTool, navigation, toggleAddMachine, role }}
            />
          </View>
          <View style={{ flex: 1 }}>
            <Navigation {...{ ...props, role }} />
          </View>
        </View>
      </View>
    );
  }

  return (
    <View style={{ flex: 1 }}>
      <ActivateDevice />
      <View style={{ width: '100%', height: '100%' }}>
        <Navigation {...{ ...props, selectedTab, role }} />
      </View>
    </View>
  );
};

const ProfileWrapper = (props) => {
  const { C } = props;

  const toggleInviteUser = () => {
    Popup({
      Component: InviteUserModal,
    });
  };

  const toggleAddTool = () => {
    Popup({
      Component: (p) => (
        <AddTool
          {...{
            ...p,
            showAddTool: true,
            toogleShowAddTool: p.hide,
            rounded: !isPhone,
          }}
        />
      ),
    });
  };

  const toggleChangeLanguage = () => {
    Popup({
      Component: ChangeLanguageModal,
    });
  };

  const toggleChangeTheme = () => {
    Popup({
      Component: ChangeThemeModal,
    });
  };

  const toggleAddMachine = () => {
    Popup({
      Component: AddMachineModal,
      width: 480,
    });
  };

  return (
    <View style={{ backgroundColor: C('Background/Light/Detail'), width: '100%', height: '100%' }}>
      <Profile {...{ ...props, toggleChangeLanguage, toggleChangeTheme, toggleInviteUser, toggleAddTool, toggleAddMachine }} />
    </View>
  );
};

export default connect(null, {})(ColorWrapper(ProfileWrapper));
